var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "col-xl-3 col-lg-4" }, [
    _c("div", { staticClass: "m-portlet m-portlet--full-height" }, [
      _c("div", { staticClass: "m-portlet__body" }, [
        _c("div", { staticClass: "m-card-profile" }, [
          _c("div", { staticClass: "m-card-profile__title m--hide" }, [
            _vm._v(
              "\n          " +
                _vm._s(_vm._f("capitalize")("my_profile")) +
                "\n        "
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "m-card-profile__details" }, [
            _c("span", { staticClass: "m-card-profile__name" }, [
              _vm._v("\n            " + _vm._s(_vm.fullName) + "\n          ")
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "ul",
          { staticClass: "m-nav m-nav--hover-bg m-portlet-fit--sides" },
          [
            _c("li", { staticClass: "m-nav__separator m-nav__separator--fit" }),
            _vm._v(" "),
            _c("li", { staticClass: "m-nav__section m--hide" }, [
              _c("span", { staticClass: "m-nav__section-text" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm._f("capitalize")("section")) +
                    "\n          "
                )
              ])
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "m-nav__item" }, [
              _c(
                "a",
                {
                  staticClass: "m-nav__link",
                  attrs: { href: "../header/profile&demo=default.html" }
                },
                [
                  _c("i", {
                    staticClass: "m-nav__link-icon flaticon-profile-1"
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "m-nav__link-title" }, [
                    _c("span", { staticClass: "m-nav__link-wrap" }, [
                      _c("span", { staticClass: "m-nav__link-text" }, [
                        _vm._v(
                          "\n                  " +
                            _vm._s(_vm._f("titleize")("my_profile")) +
                            "\n                "
                        )
                      ])
                    ])
                  ])
                ]
              )
            ])
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7b778a88", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b778a88","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/src/components/profile/BarContainer.vue
// module id = 582
// module chunks = 0 1 72 192